import { WritePermissionKey } from "constants/permissions";
import { useHasWritePermission } from "hooks/useHasWritePermission";
import { ReactNode } from "react";

type LockedUiByFeatureProps = {
  children: ReactNode;
  blockedUi?: ReactNode;
  feature: WritePermissionKey;
  level?: "FULL" | "READ_ONLY";
};

const LockedUiByFeature = ({
  children,
  blockedUi = null,
  feature,
  level,
}: LockedUiByFeatureProps) => {
  const hasWritePermission = useHasWritePermission(feature, level);

  if (!hasWritePermission) {
    return blockedUi;
  }

  return children;
};

type LockedUiProps =
  | LockedUiByFeatureProps
  | {
      children: ReactNode;
      blockedUi?: ReactNode;
      hasAccess: boolean | undefined;
    };

export const LockedUi = (props: LockedUiProps) => {
  if ("hasAccess" in props) {
    const { children, blockedUi = null, hasAccess } = props;

    if (!hasAccess) {
      return blockedUi;
    }

    return children;
  }

  return <LockedUiByFeature {...props} />;
};
